// OutFlowLoanDetails.jsx

import React, { useState } from "react";
import { Grid, withStyles } from "@material-ui/core";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { formatAmount } from "utils/Utils";
import { numericValueRegex } from "utils/Utils";
import { creditAssessmentFields } from "assets/properties/properties";
import Button from "components/CustomButtons/Button.js";
import LoanDetailsDialog from "./LoanDetailsDialog";
import { Link } from "@material-ui/core";
import CibilObligationsDialog from "./CibilObligationsDialog";
const styles = () => ({
  mainContainer: {
    width: "100%",
    margin: "20px auto",
    boxShadow: "0 10px 15px rgba(0,0,0,0.04)",
    border: "1px solid rgba(0,0,0,0.04)",
    padding: "10px 25px",
  },
  uploadContainer: {
    '& div[role="button"]': {
      height: "150px !important",
      margin: "0px 10px !important",
    },
  },
});
const OutFlowLoanDetails = ({
  classes,
  actualLoanAmount = 0,
  totalOutflowAmt = 0,
  creditScore = 0,
  exposureData,
  onCalculateCreditScore,
  otherEmi,
  getLoanArray,
  totalOutstandingAmount,
  totalPreviousLoanInterestAmount,
  totalCurrentLoanInterestAmount,
  allowedOutFlowValue,
  cibilObiligationsData,
}) => {
const [loanDialogOpen, setLoanDialogOpen] = useState(false);
const [cibilDialogOpen, setCibilDialogOpen] = useState(false);
  const totalOutFlow = () =>{
    return (
      <>
      <Grid
        item
        xs={12}
        md={2}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        {Number(creditScore) > 0 ? (
          <>
            <span style={{ fontSize: 13, fontWeight: 700 }}>
              Credit Score
            </span>
            <span
              style={{
                fontSize: 22,
                fontWeight: 700,
                color: "green",
              }}
            >
              {creditScore}
            </span>
          </>
        ) : (
          <Button
            onClick={onCalculateCreditScore}
            style={{
              background: "linear-gradient(90deg, #4F46E5 0%, #7C3AED 100%)",
              color: "#fff",
              px: 4,
              py: 1.5,
              borderRadius: "12px",
              fontSize: "16px",
              fontWeight: 700,
              textTransform: "none",
              boxShadow: "0 8px 20px rgba(79, 70, 229, 0.35)",
              transition: "all 0.3s ease",
              "&:hover": {
                background: "linear-gradient(90deg, #4338CA 0%, #6D28D9 100%)",
                transform: "translateY(-2px)",
                boxShadow: "0 12px 24px rgba(79, 70, 229, 0.45)",
              },
              "&:active": {
                transform: "translateY(1px)",
              },
            }}
          >
            📊 Check Credit Score
          </Button>
        )}
      </Grid>
      <Grid item xs={12} md={2}  style={{display:"flex", flexDirection:'column', textAlign:'right'}}>
      <span style={{fontSize:'13px', fontWeight:700}}>Total Outflow</span>
      <span style={{fontSize:'22px', fontWeight:700}}>{formatAmount(totalOutflowAmt)}</span>
      </Grid>
      </>
    )
  }
  return (
    <Grid container spacing={2} className={classes.mainContainer}>
      <Grid item xs={12}>
        <SubHeader label={creditAssessmentFields.outflowLabel}  message={totalOutFlow()} withRightText/>
      </Grid>
      <Grid item xs={12} md={3} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Existing Total Loan Amount"
          value={formatAmount(totalOutstandingAmount, false)}
          disabled
        />
        {exposureData?.loans?.length > 0 &&
          <Link
            component="button"
            variant="body2"
            onClick={() => setLoanDialogOpen(true)}
            style={{
              marginTop: 6,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            View Loans
          </Link>
        }
      </Grid>

     <Grid item xs={12} md={3} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Current Amount"
          value={formatAmount(actualLoanAmount, false)}
          disabled
        />
      </Grid>
      {Number(exposureData?.currentLoanFutureInterest) > 0 &&
        <Grid item xs={12} md={3} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Future Interest (Current loan)"
             value={formatAmount(totalCurrentLoanInterestAmount, false)}
             disabled
           />
        </Grid>
      }
     <Grid item xs={12} md={3} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Other Obligations (Monthly)"
          value={formatAmount(otherEmi,false)}
          disabled
        />
        {cibilObiligationsData?.length > 0 && (
            <Link
              component="button"
              variant="body2"
              onClick={() => setCibilDialogOpen(true)}
              style={{
                marginTop: 6,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              View Obligations
            </Link>
        )}
      </Grid>
      <Grid item xs={12} md={3} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Max Eligible loan amount"
          value={formatAmount(allowedOutFlowValue, false)}
          disabled
        />
      </Grid>
      {loanDialogOpen &&
        <LoanDetailsDialog
          open={loanDialogOpen}
          onClose={() => setLoanDialogOpen(false)}
          loans={exposureData?.loans || []}
        />
      }
      {cibilDialogOpen &&
        <CibilObligationsDialog
          open={cibilDialogOpen}
          onClose={() => setCibilDialogOpen(false)}
          obligations={cibilObiligationsData}
        />
      }
    </Grid>
  );
};

export default withStyles(styles)(OutFlowLoanDetails);
